module.exports = __webpack_public_path__ + "img/9.668bc4be.gif";